import { Component } from '@angular/core';

@Component({
  selector: 'app-welcome',
  imports: [],
  templateUrl: './welcome.html',
  styleUrl: './welcome.scss',
})
export class Welcome {
  onLearnMore() {
    // TODO: Navigate to learn more page or scroll to features section
    console.log('Learn More clicked');
  }

  onContactUs() {
    // TODO: Navigate to contact page or open contact modal
    console.log('Contact Us clicked');
  }
}
